import CampanhaModel from "../models/programafidelidade/campanhaModel";
import nfetch from "../utils/events/nfetch";

import { iServiceCached } from "./base/iServiceCached";

class CampanhaService extends iServiceCached<CampanhaModel> {
    constructor() {
        super("Campanha");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(item => ({
            value: item.id,
            text: item.descricao,
            padrao: item.padrao,
        }));
    }

    public listRecompensas(campanhaId: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/ListRecompensas?campanhaId=${campanhaId}`, {
            credentials: "same-origin",
        });
    }

    public getPontosByDocumento(documento: string): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetPontosByDocumento?documento=${documento}`, {
            credentials: "same-origin",
        });
    }

    public getPontosByCampanha(documento: string, campanhaId: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetPontosByCampanha?documento=${documento}&campanhaId=${campanhaId}`, {
            credentials: "same-origin",
        });
    }

    public pontuarByCliente(clienteId: number, campanhaId: number, pontos: number): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/PontuarByCliente?clienteId=${clienteId}&campanhaId=${campanhaId}&pontos=${pontos}`,
            {
                method: "POST",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
    }
}

export default new CampanhaService();
